import CaseStudyDetailSection from './CaseStudyDetailSection';

export default CaseStudyDetailSection;
